import React from 'react';
import { Link } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { Typography } from 'antd';
import { PRINTERS_PATH } from '../utils/constants';
import SearchTable from './SearchTable'
import { compareStrings, TrimNan } from '../utils/utils';

const layout = {
    bordered : false,
    showSizeChanger : true, 
    pagination : {pageSize: 100, showSizeChanger: false},
    size: "small",
    rowKey : record => record.id,
};

const DeviceCounters = (props) => {

    const columns = [   
        {
            title: <FormattedMessage id="DeviceMetersTable.name"/>,
            dataIndex: 'prnName',
            
            width: 300,
            search: true,
            sorter: {
                    compare: (a, b) => compareStrings(a.prnName, b.prnName),
            },
            render: (_, record) => {
                if (record.enabled === 1)
                {
                    const url = PRINTERS_PATH + "/" + record.id;
                    return(
                    <div>
                        <Link to={url}>{record.prnName}</Link>
                    </div>
                    );        
                }
                else
                {
                    return(<Typography.Text disabled>{record.prnName}</Typography.Text>);
                }
            }
        },    
        {
            title: <FormattedMessage id="SuppliesHistoryTable.model"/>,
            dataIndex: 'model',
            
            width: 200,
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.model, b.model),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.ip"/>,
            dataIndex: 'ip',
            
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.ip, b.ip)
            },
            render: (_, record) => {
                    return(
                    <div>
                        <a href={'http://' + record.ip} target='_blank' rel="noopener noreferrer">{record.ip}</a>
                    </div>
                    );        
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.pages"/>,
            dataIndex: 'pagesCount',
            
            align: 'right',
            search: true,             
            sorter: {
                compare: (a, b) =>  TrimNan(a.pagesCount) -  TrimNan(b.pagesCount)
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.color_pages"/>,
            dataIndex: 'colorPagesCount',
               
            align: 'right',
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.colorPagesCount) - TrimNan(b.colorPagesCount),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.bw_pages"/>,
            dataIndex: 'blackPagesCount',
              
            align: 'right', 
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.blackPagesCount) - TrimNan(b.blackPagesCount),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.printer_pages"/>,
            dataIndex: 'printerPagesCount',
             
            align: 'right',  
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.printerPagesCount) - TrimNan(b.printerPagesCount),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.printer_color_pages"/>,
            dataIndex: 'colorPrinterPagesCount',
             
            align: 'right',  
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.colorPrinterPagesCount) - TrimNan(b.colorPrinterPagesCount),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.printer_bw_pages"/>,
            dataIndex: 'blackPrinterPagesCount',
               
            align: 'right',
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.blackPrinterPagesCount) - TrimNan(b.blackPrinterPagesCount),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.copier_pages"/>,
            dataIndex: 'copierPagesCount',
              
            align: 'right', 
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.copierPagesCount) - TrimNan(b.copierPagesCount),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.copier_color_pages"/>,
            dataIndex: 'colorCopierPagesCount',
             
            align: 'right',  
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.colorCopierPagesCount) - TrimNan(b.colorCopierPagesCount),
            },
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.copier_bw_pages"/>,
            dataIndex: 'blackCopierPagesCount',
            
            align: 'right',   
            search: true,             
            sorter: {
                compare: (a, b) => TrimNan(a.blackCopierPagesCount) - TrimNan(b.blackCopierPagesCount),
            },
        },

    ];   
        
    return (
        <div className = "report-table">
            <SearchTable
                layout = {layout}
                type = {undefined}
                columns={columns} 
                dataSource={props.data} 
            />
        </div>
    );
}

export default DeviceCounters;
